let animating = false
let animationFrame = 0

function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3)
}

export function fanOut(postits, centerX, centerY, onComplete) {
    animating = true
    animationFrame = 0

    const fanOutCount = 20
    const duration = 90 // frames (~1.5s at 60fps)
    const staggerDelay = 2.4 // frames between each start

    // Set initial state
    for (let i = 0; i < postits.length; i++) {
        const postit = postits[i]
        postit.alpha = 0

        if (i < fanOutCount) {
            // First batch: animate from center
            postit.x = centerX
            postit.y = centerY
            postit.scale.set(0.5)
            postit.rotation = 0
        } else {
            // Rest: already at final position, just fade in
            postit.x = postit.targetX
            postit.y = postit.targetY
            postit.scale.set(1)
            postit.rotation = postit.targetRotation
        }
    }

    function tick() {
        animationFrame++
        let allDone = true

        for (let i = 0; i < postits.length; i++) {
            const postit = postits[i]
            const delay = i * staggerDelay
            const elapsed = animationFrame - delay

            if (elapsed <= 0) {
                allDone = false
                continue
            }

            const progress = Math.min(elapsed / duration, 1)
            const eased = easeOutCubic(progress)

            if (i < fanOutCount) {
                postit.x = centerX + (postit.targetX - centerX) * eased
                postit.y = centerY + (postit.targetY - centerY) * eased
                postit.scale.set(0.5 + 0.5 * eased)
                postit.rotation = postit.targetRotation * eased
            }

            postit.alpha = eased

            if (progress < 1) {
                allDone = false
            }
        }

        if (allDone) {
            animating = false
            if (onComplete) onComplete()
        } else {
            requestAnimationFrame(tick)
        }
    }

    requestAnimationFrame(tick)
}

export function isAnimating() {
    return animating
}
